import React from 'react'
import linkedin from '../../Assets/icons/social/linkedin.svg'
import facebook from '../../Assets/icons/social/facebook.svg'
import twitter from '../../Assets/icons/social/twitter.svg'

function Social() {
    return (
        <div className='flex flex-row'>
            <div className='border rounded-[50%] flex p-3 mr-5'>
                <img src={linkedin} alt="" />
            </div>
            <div className='border rounded-[50%] flex p-3 mr-5'>
                <img src={facebook} alt="" />
            </div>  
            <div className='border rounded-[50%] flex p-3'>
                <img src={twitter} alt="" />
            </div>
        </div>
    )
}

export default Social